import { __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltRecorderPlayerAudioContainerWireframe from './VeltRecorderPlayerAudioContainerWireframe/VeltRecorderPlayerAudioContainerWireframe';
import VeltRecorderPlayerVideoContainerWireframe from './VeltRecorderPlayerVideoContainerWireframe/VeltRecorderPlayerVideoContainerWireframe';
var VeltRecorderPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecorderPlayerWireframe.AudioContainer = VeltRecorderPlayerAudioContainerWireframe;
VeltRecorderPlayerWireframe.VideoContainer = VeltRecorderPlayerVideoContainerWireframe;
export default VeltRecorderPlayerWireframe;
